import React, {PropTypes} from 'react';
import moment from 'moment';
import classNames from 'classnames';
import {formatCurrency} from 'shared/util/formatCurrency';
import DisplayIf from 'shared/DisplayIf.jsx';
Number.prototype.formatCurrency = formatCurrency;

const Entry = ({
  balanceDue,
  eventName,
  name,
  entryNumber,
  id,
  tournamentId,
  isCancelled,
  selected,
  selectable,
  squadDateTime,
  timeZoneDisplayName,
  onSelectChecked,
  onNavigationClick
}) => (
  <div className="list-group-item-labeled">
    {isCancelled
      ? <div className="list-group-item-labeled-child custom-checkbox-container"
          style={{width: 25}} />
      : <div className="list-group-item-labeled-child custom-checkbox-container"
          style={{width: 25}}>
          <input
            type="checkbox"
            id={`entry-${id}`}
            disabled={!selectable}
            checked={selected}
            onChange={() => onSelectChecked(tournamentId, id)}
          />
          <label
            htmlFor={`entry-${id}`} />
        </div>
    }
    <div className="list-group-item-labeled-child"
      style={{width: 125}}>
      <span>{'Event Name'}</span>
      <span>{`${eventName}`}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 250}}>
      <span>{'Team Name'}</span>
      <span>{name}</span>
    </div>
    <a className="list-group-item-labeled-child has-link"
      style={{width: 120}}
      onClick={() => onNavigationClick(`admin/entry/${id}`)}>
      <span>{'Reservation Number'}</span>
      <span>{entryNumber || '-'}</span>
    </a>
    <DisplayIf condition={moment.parseZone(squadDateTime).second() === 10}>
      <div className="list-group-item-labeled-child"
        style={{width: 250, color: 'red'}}>
        <span>{'Date'}</span>
        <span>
          {
              squadDateTime
            ? `${moment.parseZone(squadDateTime).format('hh:mm A, MMM Do, YYYY')}
            (${timeZoneDisplayName})`
            : isCancelled ? 'CANCELLED' : '-'
          }
        </span>
      </div>
    </DisplayIf>
    <DisplayIf condition={moment.parseZone(squadDateTime).second() === 0}>
    <div className="list-group-item-labeled-child"
        style={{width: 250}}>
        <span>{'Date'}</span>
        <span>
          {
              squadDateTime
            ? `${moment.parseZone(squadDateTime).format('hh:mm A, MMM Do, YYYY')}
            (${timeZoneDisplayName})`
            : isCancelled ? 'CANCELLED' : '-'
          }
        </span>
      </div>
    </DisplayIf>
    {isCancelled
      ? <div className="list-group-item-labeled-child"
          style={{width: 145}} />
      : <div className={classNames(
            'list-group-item-labeled-child',
            {'bg-danger': balanceDue}
          )}
          style={{width: 145, height: 40, alignItems: 'center', justifyContent: 'center'}}>
          {
            balanceDue
            ? <strong className="flex center" >{`$${balanceDue.formatCurrency(2)} DUE`}</strong>
            : null
          }
        </div>
    }
  </div>
);

Entry.propTypes = {
  addressBase: PropTypes.string,
  balanceDue: PropTypes.number,
  eventName: PropTypes.string,
  name: PropTypes.string,
  entryNumber: PropTypes.string,
  squadDateTime: PropTypes.string,
  timeZoneDisplayName: PropTypes.string,
  id: PropTypes.string,
  tournamentId: PropTypes.string,
  isCancelled: PropTypes.bool,
  selected: PropTypes.bool,
  selectable: PropTypes.bool,
  onSelectChecked: PropTypes.func,
  onNavigationClick: PropTypes.func
};

Entry.defaultProps = {
  balanceDue: 0
};

export default Entry;



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/Entry.jsx